<div class="rt-trip-criteria-dialog">
    <mat-dialog-content class="dialog-content">
        <rt-trip-criteria
            [customerNumber]="customerNumber"
            [destinationCity]="destinationCity"
            [destinationState]="destinationState"
            [originCity]="originCity"
            [originState]="originState"
            [tripId]="tripId"
            [returnCity]="returnCity"
            [returnState]="returnState"
            [showDestinationCriteria]="showDestinationCriteria"
            [showOriginCriteria]="showOriginCriteria"
            (criteriaChanged)="onCriteriaChanged()"
        ></rt-trip-criteria>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button type="button" (click)="onCancel()" color="accent">Cancel</button>
    </mat-dialog-actions>
</div>
